export function parseUtcDateAsLocal(
  isoDateString: string | null | undefined,
): Date | null {
  if (!isoDateString) return null;
  const datePart = isoDateString.split('T')[0];
  const [year, month, day] = datePart.split('-').map(Number);
  return new Date(year, month - 1, day);
}

export function getDateString(
  isoDateString: string | null | undefined,
): string {
  if (!isoDateString) return '';
  return isoDateString.split('T')[0];
}

export function formatUtcDateAsLocal(
  isoDateString: string | null | undefined,
  options: Intl.DateTimeFormatOptions = {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  },
): string {
  const date = parseUtcDateAsLocal(isoDateString);
  if (!date) return '';
  return date.toLocaleDateString('en-US', options);
}

export function parseIsoDate(
  isoDateString: string | null | undefined,
): Date | null {
  if (!isoDateString) return null;
  return new Date(isoDateString);
}

export function formatTime(date: Date | null): string {
  if (!date) return '-';
  const hours = String(date.getUTCHours()).padStart(2, '0');
  const minutes = String(date.getUTCMinutes()).padStart(2, '0');
  return `${hours}:${minutes}`;
}
